import { useState } from 'react';
import { Paper, Accordion, AccordionSummary, AccordionDetails, Grid, Typography, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { formatCurrency } from '../../../common/Helper';

const DividendsBox = (props) => {
	const {dividends, market, exchangeRate, portfolioSummary} = props;

	const [expanded, setExpanded] = useState(false);

	const handleChange = (event, isExpanded) => {
		setExpanded(isExpanded);
	};
	
	let filteredEarnings	= dividends.filter(d => d.market === market)
	let totalEarnings 		= filteredEarnings.reduce((acc, d) => acc + d.earnings, 0)
	let montlyEarnings 		= totalEarnings/12
	let earningsSummary 	= []

	const assetType 		= market === 'BR' ? 'Ações' : 'Stocks'

	for (let earning of filteredEarnings) {
		let index = earningsSummary.findIndex(e => e.stockTicker === earning.stockTicker)

		if (index >= 0) { 
			earningsSummary[index].earnings = earningsSummary[index].earnings + parseFloat(earning.earnings)
		}
		else {
			earningsSummary.push({
				stockTicker : earning.stockTicker,
				earnings    : parseFloat(earning.earnings)
			})
		}
	}

	const columns = [
		{ 
			field: 'stockTicker', 
			headerName: 'Ticker', 
			renderCell: (cellValues) => {	
				return <a href={`/company/${cellValues.row.stockTicker}`}>{cellValues.row.stockTicker}</a>;
			},
			disableColumnMenu : true
		},
		{ 
			field: 'earnings', 
			headerName: 'Valor', 
			renderCell: (cellValues) => {
				return ( formatCurrency(cellValues.row.earnings, 'SMALL') )
			},
			disableColumnMenu : true
		},        
		{ 
			field: 'yield', 
			headerName: 'Yield on Cost', 
			valueGetter: (cellValues, row) => {
				return ((row.earnings / (portfolioSummary.find(i => i.identificador === row.identificador).cost * exchangeRate))*100)
			},
			valueFormatter: (params) => {
				return (params).toFixed(2) +"%"
			},
			disableColumnMenu : true
		},
		{ 
			field: 'payout', 
			headerName: 'Payout', 
			disableColumnMenu : true
		},            
	];	

	return (
		<Paper elevation={2} sx={{paddingTop:1, paddingLeft:1, paddingRight:1}}>
			<Accordion
				expanded={expanded}
				onChange={handleChange}
				sx={{border: 'none', boxShadow: 'none'}}>
				<AccordionSummary
					aria-controls="panel1a-content"
					id="panel1a-header"
					>
					<Grid container spacing={1}> 
						<Grid item xs={12}>
							<Typography variant='h5' fontWeight={800} align='center'>Proventos das {assetType}</Typography>
						</Grid> 
						<Grid item xs={6}>
							<Paper>
								<Stack alignItems="center" gap={0} padding={1}>
									<Typography variant='h6'>Anual</Typography>
									<Typography variant='h6' align="center" fontWeight={800}>
										{formatCurrency(totalEarnings, 'SMALL')}
									</Typography>
									<Typography fontSize={'0.75rem'}>
										Yield: {((totalEarnings/portfolioSummary.filter(i => i.assetType === 'ACAO').reduce((acc, i) => acc + parseFloat(i.cost), 0)*100).toFixed(2))}%
										
									</Typography>
								</Stack>
							</Paper>
						</Grid>
						<Grid item xs={6}>
							<Paper>
								<Stack alignItems="center" spacing={0} padding={1}>
									<Typography variant='h5'>Mensal</Typography>
									<Typography variant='h6' align="center" fontWeight={800}>
										{formatCurrency(montlyEarnings, 'SMALL')}
									</Typography>
									<Typography fontSize={'0.75rem'}>
										Yield: {((montlyEarnings/portfolioSummary.filter(i => i.assetType === 'ACAO').reduce((acc, i) => acc + parseFloat(i.cost), 0)*100).toFixed(2))}%
									</Typography>
								</Stack>
								
							</Paper>
						</Grid>
						<Grid item xs={12} justifyContent={'center'} display={'flex'}>
							{expanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
						</Grid>
					</Grid>
				</AccordionSummary>
				<AccordionDetails>
				<DataGrid
					getRowId={(row) => row.stockTicker} 
					rows={earningsSummary}
					columns={columns}
					pageSize={20}
					rowHeight={30}
					sx={{
						fontSize:12,
						height: '100%',
						width: '100%',
						'& .super-app-theme--cell': {
							backgroundColor: 'rgba(224, 183, 60, 0.55)',
							color: '#1a3e72',
							fontWeight: '600',
						},
						'& .super-app.negative': {
							color: '#008000', 
							fontWeight: '600',
						},
						'& .super-app.positive': {
							color: '#FF0000',
							fontWeight: '600',
						},
					}} 
				/>
				</AccordionDetails>
			</Accordion>
			
		</Paper>
	)
}

export default DividendsBox;